import { z } from 'zod';

// original at https://github.com/lessonup/lessonup/blob/a3ac598bc65668a5d456f348e2e8ac9ac3eec5b1/libs/lessonup-core/src/domain/assignment/AssignmentMeta.ts

export const DbAssignmentStatusSchema = z.enum(['open', 'closed']);

export const DbAssignmentMetaSchema = z.object({
  _id: z.string(),
  assignmentInfo: z.object({
    name: z.string(),
    numberOfPins: z.number(),
    ownerId: z.string(),
    pin: z.any().optional(),
    subject: z.string(),
  }),
  createdAt: z.number(),
  lessonId: z.string(),
  modifiedAt: z.number(),
  ownerId: z.string(),
  products: z.array(z.string()),
  status: DbAssignmentStatusSchema,
  teacherActivityAt: z.number(),
  type: z.enum(['realtime', 'test']), // TODO, how to do we want to model different types of assignments?
  usersWithAccess: z.array(z.string()),
  version: z.literal('v2').nullish(),
});

export type DbAssignmentMeta = z.infer<typeof DbAssignmentMetaSchema>;
export type DbAssignmentStatus = z.infer<typeof DbAssignmentStatusSchema>;

export function assignmentMetaGrantsTeacherAccess(userId: string, meta: DbAssignmentMeta): boolean {
  return meta.ownerId === userId || meta.usersWithAccess.includes(userId);
}
